import { _post, _get, _delete } from "./Axios";

export default class UnitKerjaApi {
  static get(id = null) {
    if (id == null) {
      return _get("office/unitkerja");
    } else {
      return _get("office/unitkerja/" + id);
    }
  }
  static getbyparam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("office/unitkerja?" + params);
  }
  static post(data) {
    return _post("office/unitkerja", data);
  }
  static update(id, data) {
    return _post("office/unitkerja/" + id, data);
  }
  static delete(id) {
    return _delete("office/unitkerja/" + id);
  }
}
